import React from "react";

export const SoftwareEngineeringIcon = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="16 18 22 12 16 6" />
    <polyline points="8 6 2 12 8 18" />
    <line x1="14" y1="4" x2="10" y2="20" />
  </svg>
);

export const BrandCreativeIcon = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="13.5" cy="6.5" r=".5" fill={color} />
    <circle cx="17.5" cy="10.5" r=".5" fill={color} />
    <circle cx="8.5" cy="7.5" r=".5" fill={color} />
    <circle cx="6.5" cy="12.5" r=".5" fill={color} />
    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.992 6.01 17.52 2 12 2z" />
  </svg>
);

export const DigitalMarketingIcon = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3 3v18h18" />
    <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3" />
    <polyline points="15 8 19 8 19 12" />
  </svg>
);

export const SocialContentIcon = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

export const CloudDevOpsIcon = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
    <polyline points="12 12 12 16 14 14" />
  </svg>
);

export const AiAutomationIcon = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    <circle cx="12" cy="12" r="4" />
  </svg>
);

export const EcommerceGrowthIcon = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    <path d="M12 9l3 3 4-4" />
  </svg>
);

export const MediaProductionIcon = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polygon points="23 7 16 12 23 17 23 7" />
    <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
  </svg>
);

export const StrategyConsultingIcon = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
  </svg>
);

export const IntegrationsEnterpriseIcon = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="2" y="2" width="8" height="8" rx="2" />
    <rect x="14" y="2" width="8" height="8" rx="2" />
    <rect x="14" y="14" width="8" height="8" rx="2" />
    <rect x="2" y="14" width="8" height="8" rx="2" />
    <line x1="6" y1="10" x2="6" y2="14" />
    <line x1="10" y1="6" x2="14" y2="6" />
    <line x1="18" y1="10" x2="18" y2="14" />
    <line x1="10" y1="18" x2="14" y2="18" />
  </svg>
);

export const ServiceIcon = ({ iconKey, slug, size = 24, color = "currentColor", ...props }) => {
  const normalizedKey = (iconKey || slug || "").toLowerCase();

  if (normalizedKey.includes("software") || normalizedKey.includes("web") || normalizedKey.includes("app") || normalizedKey.includes("erp") || normalizedKey.includes("qa") || normalizedKey.includes("code")) {
    return <SoftwareEngineeringIcon size={size} color={color} {...props} />;
  }
  if (normalizedKey.includes("brand") || normalizedKey.includes("creative") || normalizedKey.includes("logo") || normalizedKey.includes("design") || normalizedKey.includes("graphic")) {
    return <BrandCreativeIcon size={size} color={color} {...props} />;
  }
  if (normalizedKey.includes("market") || normalizedKey.includes("seo") || normalizedKey.includes("growth") || normalizedKey.includes("ppc") || normalizedKey.includes("content")) {
    return <DigitalMarketingIcon size={size} color={color} {...props} />;
  }
  if (normalizedKey.includes("social") || normalizedKey.includes("instagram") || normalizedKey.includes("influencer")) {
    return <SocialContentIcon size={size} color={color} {...props} />;
  }
  if (normalizedKey.includes("cloud") || normalizedKey.includes("devops") || normalizedKey.includes("aws") || normalizedKey.includes("azure") || normalizedKey.includes("infra")) {
    return <CloudDevOpsIcon size={size} color={color} {...props} />;
  }
  if (normalizedKey.includes("ai") || normalizedKey.includes("automation") || normalizedKey.includes("bot") || normalizedKey.includes("data")) {
    return <AiAutomationIcon size={size} color={color} {...props} />;
  }
  if (normalizedKey.includes("ecom") || normalizedKey.includes("shop") || normalizedKey.includes("amazon") || normalizedKey.includes("flipkart") || normalizedKey.includes("retail")) {
    return <EcommerceGrowthIcon size={size} color={color} {...props} />;
  }
  if (normalizedKey.includes("video") || normalizedKey.includes("media") || normalizedKey.includes("photo") || normalizedKey.includes("production") || normalizedKey.includes("film")) {
    return <MediaProductionIcon size={size} color={color} {...props} />;
  }
  if (normalizedKey.includes("strategy") || normalizedKey.includes("consult") || normalizedKey.includes("advisory") || normalizedKey.includes("transform")) {
    return <StrategyConsultingIcon size={size} color={color} {...props} />;
  }
  if (normalizedKey.includes("integ") || normalizedKey.includes("api") || normalizedKey.includes("connect") || normalizedKey.includes("salesforce") || normalizedKey.includes("plugin")) {
    return <IntegrationsEnterpriseIcon size={size} color={color} {...props} />;
  }

  return <SoftwareEngineeringIcon size={size} color={color} {...props} />;
};

export default ServiceIcon;
